import React from "react";
import { Avatar } from "@mui/material";

const AvatarIcon = ({ widgetIcon }) => {
  return <Avatar id="avatar-style-1">{widgetIcon}</Avatar>;
};

export default AvatarIcon;
